import ResponseEntity, { toEnum } from "..";
import {
  IsString,
  IsInt,
  IsBoolean,
  ValidateIf,
  IsEnum,
} from "class-validator";

import { Transform } from "class-transformer";

export enum LcMemberType {
  "full" = "full",
  "obs" = "obs",
  "no" = "no",
  "past" = "past",
}

export default class OutputLc extends ResponseEntity {
  @IsString() public readonly id!: string;
  @IsString() public readonly name!: string;
  @IsString() public readonly name_short!: string;
  @IsString() public readonly city!: string;

  @ValidateIf((obj) => obj.hierarchy !== null)
  @IsInt()
  public readonly hierarchy!: number | null;

  @Transform(toEnum(LcMemberType))
  @IsEnum(LcMemberType, {
    message: "LcMemberType must be full, obs, no or past",
  })
  public readonly member!: LcMemberType;

  @IsBoolean() public readonly transmed!: boolean;
  @IsBoolean() public readonly exchanges!: boolean;
  @IsString() public readonly school!: string;
}

export class PublicLc extends ResponseEntity {
  @IsString() public readonly id!: string;
  @IsString() public readonly name!: string;
  @IsString() public readonly name_short!: string;
  @IsString() public readonly city!: string;
  @IsString() public readonly logo!: string;

  @ValidateIf((obj) => obj.hierarchy !== null)
  @IsInt()
  public readonly hierarchy!: number | null;

  @Transform(toEnum(LcMemberType))
  @IsEnum(LcMemberType, {
    message: "LcMemberType must be full, obs, no or past",
  })
  public readonly member!: LcMemberType;

  @IsBoolean() public readonly transmed!: boolean;
  @IsBoolean() public readonly exchanges!: boolean;
  @IsString() public readonly school!: string;

  @IsInt() public readonly map_x!: number;
  @IsInt() public readonly map_y!: number;
}
